import React from 'react'

import { ActionButtonProps } from '../../ActionButton'
import { Icons } from '../../Icon/types'

import * as SC from './styled'

export type FormSubmitButtonProps = ActionButtonProps & {
  pendingText?: string
  successText?: string
  disabledText?: string
  isPending?: boolean
  isSuccess?: boolean
}

const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({
  className,
  isPending,
  isSuccess,
  disabled,
  successText,
  pendingText,
  disabledText,
  text,
  children,
  ...rest
}) => {
  const displayText =
    disabled && disabledText
      ? disabledText
      : isSuccess && successText
      ? successText
      : isPending && pendingText
      ? pendingText
      : text

  const enabled = !disabled && !isPending

  return (
    <SC.Button
      className={className}
      type="submit"
      $isPending={isPending}
      $isSuccess={isSuccess}
      disabled={!enabled}
      icon={isPending ? Icons.refresh : undefined}
      {...rest}
    >
      {children || displayText}
    </SC.Button>
  )
}
export default FormSubmitButton
